import exportFromJSON from 'export-from-json'
import _ from 'lodash'

import excelExport from './sample-data-to-excel'
import csvExport from './sample-data-to-csv'
import getLeafNodes from '/utils/get-leaf-nodes'

const downloadTemplateData = ({ template, format = 'csv', includeMailmerge = true }) => {
  if (!template) return

  const fileName = `${template.template_id}-default-variables`
  const data = [filterReadonlyVariables(template, includeMailmerge)]

  if (format === 'xls') return excelExport({ fileName, data, template })

  const exportData = format === 'csv' ? csvExport(data) : data
  exportFromJSON({
    data: exportData,
    fileName,
    exportType: format === 'csv' ? exportFromJSON.types.csv : exportFromJSON.types.json
  })
}

export default downloadTemplateData

const filterReadonlyVariables = (template, includeMailmerge) => {
  const variables = _.cloneDeep(template.variables ?? {})
  if (!Array.isArray(template.variable_catalog)) return includeMailmerge ? addMailmergeFields(variables) : variables
  const isManagedPassTemplate = Number(template.managed_pass_template) === 1

  const catalogByName = _.keyBy(template.variable_catalog, 'var_name')
  const excludedPaths = getLeafNodes(variables)
    .filter(path => {
      const item = catalogByName[path]
      return Number(item?.allowable_in_pass_data) !== 1 || (isManagedPassTemplate && Number(item?.readonly_managed) === 1)
    })

  excludedPaths.forEach(path => {
    _.unset(variables, path)
    pruneEmptyParents(variables, path)
  })

  return includeMailmerge ? addMailmergeFields(variables) : variables
}

const addMailmergeFields = variables => ({
  ...variables,
  _mailmerge: {
    name: "",
    email: ""
  }
})

const pruneEmptyParents = (obj, path) => {
  const parts = path.split(".")
  for (let i = parts.length - 1; i > 0; i -= 1) {
    const parentPath = parts.slice(0, i).join(".")
    const parentValue = _.get(obj, parentPath)
    if (_.isPlainObject(parentValue) && Object.keys(parentValue).length === 0) _.unset(obj, parentPath)
    else break
  }
}
